import isPresent from './is_present';

export default function getYoutubeEmbedUrl(youtubeUrl) {
  if (isPresent(youtubeUrl)) {
    const match = /(?:watch\?v=|^https:\/\/youtu\.be\/)(...........)/.exec(youtubeUrl);
    if (match) {
      return `https://www.youtube.com/embed/${match[1]}`;
    }
  }
  return youtubeUrl;
}
